"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function anyToKebab(s) {
  if ('string' !== typeof s) {
    return s;
  }

  var result = '',
      i = 0,
      len = s.length;

  for (; i < len; i++) {
    var lowerCased = s[i].toLowerCase();
    var upperCased = s[i].toUpperCase();

    if (lowerCased !== upperCased && s[i] === upperCased) {
      result += '-' + lowerCased;
    } else {
      result += lowerCased;
    }
  }

  return result[0] !== '-' ? result : result.substr(1);
}

var _default = anyToKebab;
exports["default"] = _default;